<template>
  <div class="qr-quota font-light">
    <div v-if="currentPlan" class="font-weight-medium">
      <span class="activated">
        {{ formatNumber(usedCodesCount) }} {{$t('used')}}
      </span>
      /
      <span>
        {{ formatNumber(totalCodesCount) }}
        {{ $t('total') }}
      </span>
    </div>
    <!-- <div v-if="totalBlacklistedAssignedCodesCount" class="inactive-ctn">
      {{ totalBlacklistedAssignedCodesCount }} {{$t('blacklisted')}}
    </div> -->
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import Utils from '@/utils/utils'

export default {
  name: 'CodesQuota',
  computed: {
    ...mapGetters(['totalBlacklistedAssignedCodesCount', 'totalCodesCount', 'usedCodesCount', 'currentPlan'])
  },
  methods: {
    formatNumber (value) {
      return Utils.formatNumber(value, this.$i18n.locale)
    }
  }
}

</script>

<style lang="sass">

@import "@/variables.sass"

.qr-quota
  display: flex
  flex-direction: column
  align-items: flex-end
  font-size: 16px
  .quota-label
    color: #999999
  .right
    text-align: right
  .activated
    color: $primary

</style>
